import { useEffect, useState } from 'react';
import { type DayPart, dayPart, msUntilNextDayPart } from '../domain/day-part';

/**
 * The current part of the day for the greeting, re-evaluated when the clock crosses the next
 * boundary — a Home left open over lunch switches from "Good morning" to "Good afternoon".
 * Timers paused in the background fire on resume, which re-reads the clock as well.
 */
export function useDayPart(): DayPart {
  const [part, setPart] = useState<DayPart>(() => dayPart(new Date()));
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    const schedule = () => {
      timer = setTimeout(() => {
        setPart(dayPart(new Date()));
        schedule();
      }, msUntilNextDayPart(new Date()));
    };
    schedule();
    return () => clearTimeout(timer);
  }, []);
  return part;
}
